<template>
    <div class="apiKey">
        <!-- <van-nav-bar v-if="$route.query.isApp != 1" title="API key" right-text="FAQ?" left-arrow @click-left="goBack()" @click-right="goFAQ" /> -->
        <van-nav-bar v-if="$route.query.isApp != 1" title="API key" left-arrow @click-left="goBack()" />
        <!-- @click-left="onClickLeft" -->
        <div class="apiBody">
            <div class="commont_body">
                <div class="commont_content">
                    <!-- 我们提供功能强大的API，帮助您高效地将交易功能整合至应用中。API分为账户、交易和行情三类，您可根据需求配置相应权限，并通过API实现自动交易。 -->
                    <span>{{$t('9100161')}}</span>
                    <!-- 查看api文档 -->
                    <div class="vitepress_box">
                        <a class="check" href="https://docs-api.superex.com">{{ $t("9100106") }}</a>
                        <span class="faq" @click="goFAQ">FAQ</span>
                    </div>
                </div>

                <div class="pageList">
                    <div class="page-item" v-for="item in pageList" :key="item.accessKey" @click="toApikey(item)">
                        <div class="item-top">
                            <div class="item-title">
                                <!-- 9100162 创建时间 -->
                                <span class="title">{{$t('9100162')}}</span>
                                <span>{{ parseTimeData(item.createTime) }}</span>
                            </div>
                            <div class="item-title">
                                <!-- 9100128   备注名 -->
                                <span class="title">{{$t('9100128')}}</span>
                                <span>{{ item.note }}</span>
                            </div>
                        </div>
                        <div class="item-line"></div>
                        <div class="item-top">
                            <div class="item-title">
                                <!-- 9100142  权限 -->
                                <span class="title">{{$t('9100142')}}</span>
                                <!-- 读取 交易-->
                                <span>{{$t('9100131')}}{{ item.freeSpotState ? "、" + $t('9100132') : "" }}</span>
                            </div>
                            <div class="item-title">
                                <span class="title">Access Key</span>
                                <span>{{ item.accessKey }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <van-empty :description="$t('300108')" v-if="!pageList.length">
                    <template #image>
                        <div class="images">
                            <img v-if="$route.query.backgroundColor == 'day'" src="../../assets/images/apikey/apiKeyBg_day.png">
                            <img v-else src="../../assets//images//apikey/apiKeyBg_moon.png">
                        </div>
                    </template>
                </van-empty>
            </div>
            <div class="flot">
                <!-- 创建api key -->
                <Button @click="goCreateApi" color="#FFC72B">{{
        $t("9100105")
      }}</Button>
            </div>
        </div>

    </div>
</template>

<script>
    import { List, Icon, NavBar, Button } from "vant";
    import {getCookie, removeCookie, removeToken, setCookie, setToken} from "../../utils/auth";
    import { parseTime } from "@/utils/index";
    import { getListdata } from "@/api/resource";
    import { Empty } from "vant";
    import { mapGetters } from "vuex";
    import { queryApiKey } from "@/api/apikey";

    export default {
        name: "apiKey",
        components: {
            vanList: List,
            vanIcon: Icon,
            vanEmpty: Empty,
            vanNavBar: NavBar,
            Button
        },
        data() {
            return {
                pageList: [],
                isApp: '',
                isLogin: '',
            };
        },
        // watch: {
        //     $route() {
        //         this.resher()
        //     },
        // },
        computed: {
            ...mapGetters(["isDirection", "token"])
        },
        methods: {
            // async getPageList() {
            //     if (this.token) {
            //         const { data } = await queryApiKey();
            //         this.pageList = data;
            //         console.log(data, "dddddddd");
            //     } else {
            //         this.$router.push(
            //             '/login?historyBack=' +
            //             window.encodeURIComponent('/apikey')
            //         )
            //     }
            // },
            goBack() {
                if (this.$route.query.isApp == 1) {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.goBack,
                        {},
                        (data) => {
                        }
                    )
                }
            },
            goFAQ() {
                const currentQueryParams = this.$route.query;
                this.$router.push({
                    path: '/FAQ',
                    query: currentQueryParams
                });
            },
            getPageList() {
                console.log(this.$route.query, 'this.$route.query----getPageList')
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                if (token) {
                    // setToken(token);
                    this.$store.dispatch('GetInfo', token);
                    // this.$store.dispatch('setToken', token);
                }
                this.$i18n.locale = this.$route.query.language ? this.$route.query.language : 'en'
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != "") {
                    window.document.documentElement.setAttribute(
                        "data-theme",
                        this.$route.query.backgroundColor === "day" ? "sunlight" : "moon"
                    );
                } else {
                    window.document.documentElement.setAttribute("data-theme", "moon");
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
                
                if (this.$route.query.token || this.token) {
                    // const { data } = await queryApiKey();
                    // this.pageList = data;
                    queryApiKey().then((res) => {
                        this.pageList = res.data || []
                    })
                }
            },
            // resher() {
            //     this.isApp = this.$route.query.isApp
            //     let token = this.$route.query.token || this.token
            //     if (token) {
            //         setToken(token);
            //         this.$store.dispatch('GetInfo', token);
            //         this.$store.dispatch('setToken', token);
            //     }
            //     this.$i18n.locale = this.$route.query.language ? this.$route.query.language : 'en'
            //     setCookie(
            //         'language',
            //         this.$route.query.language ? this.$route.query.language : 'en'
            //     )
            //     this.language = this.$route.query.language
            //         ? this.$route.query.language
            //         : 'en'
            //     this.$store.dispatch(
            //         'setIsDirection',
            //         this.$route.query.language == 'fa' ? true : false
            //     )
            //     if (this.$route.query.backgroundColor != "") {
            //         window.document.documentElement.setAttribute(
            //             "data-theme",
            //             this.$route.query.backgroundColor === "day" ? "sunlight" : "moon"
            //         );
            //     } else {
            //         window.document.documentElement.setAttribute("data-theme", "moon");
            //     }
            //     window.document.documentElement.setAttribute(
            //         'dir',
            //         this.isDirection ? 'rtl' : 'ltr'
            //     )
            // },
            async resher() {
                console.log(this.token, 'created----token')
                console.log(this.$route.fullPath,'$route.fullPath')
                console.log(this.$route.query, 'this.$route.query')
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != '') {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        this.$route.query.backgroundColor === 'day'
                            ? 'sunlight'
                            : 'moon'
                    )
                } else {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        'moon'
                    )
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
                if (this.isApp == 1) {
                    this.$i18n.locale = this.language
                    if (token) {
                        setToken(token)
                        // this.$store.dispatch('GetInfo', token)
                        await this.$store.dispatch('setToken', token)
                        this.isLogin = true
                        this.getPageList();
                    } else {
                        console.log('这里')
                        removeToken()
                        this.isLogin = false
                    }
                } else {
                    this.isLogin = getCookie('token') ? true : false
                    if (this.isLogin) {
                        this.getPageList();
                    } else {
                        removeToken()
                    }
                }
            },
            appLogin() {
                if (this.$route.query.isApp == 1 || this.isApp == 1) {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.appLogin,
                        {
                            code: 200,
                            type: "login",
                            url: window.location.href.toString().split("?")[0] + `?id=${this.$route.query.id}`
                        },
                        data => {
                        }
                    );
                } else {
                    // this.$router.push({ path: '/login', query: { historyBack: `/createKey` } });
                    // console.log('??');
                    const currentQueryParams = this.$route.query;
                    this.$router.push({
                        path: '/login',
                        query: {
                            historyBack: '/createKey?' + 'backgroundColor=' + this.$route.query.backgroundColor + '&language=' + this.$route.query.language,
                            backgroundColor: this.$route.query.backgroundColor,
                            language: this.$route.query.language
                        },
                    });
                }
            },
            goCreateApi() {
                if (this.$route.query.token || this.token) {
                    const currentQueryParams = this.$route.query;
                    this.$router.push({
                        path: '/createKey',
                        query: currentQueryParams
                    });
                } else {
                    this.appLogin()
                }

            },
            parseTimeData(item) {
                return parseTime(item);
            },
            toApikey(item) {
                // this.$router.push({ path: "/apikeyDetail", query: { id: item.id } });
                this.$router.push({
                    path: '/apikeyDetail',
                    query: {
                        id: item.id,
                        backgroundColor: this.$route.query.backgroundColor,
                        language: this.$route.query.language,
                        isApp: this.$route.query.isApp,
                    },
                });
            }
        },
        created() {
            // this.resher();
            // setTimeout(()=>{
            //     this.getPageList();
            // },1000)
        },
        mounted(){
            this.getPageList();
        }
    };
</script>

<style lang="scss" scoped>
    @import "../../assets/css/variableName";
    @import "../../style/mixin";
    @import "../../assets/css/mixin";
    /deep/ .van-nav-bar__text {
        color: #d9a31a !important;
    }
    .apiKey {
        position: fixed;
        width: 100vw;
        min-height: 100vh;
        top: 0;
        left: 0;
        //background: #fff;
        @include background_color("background-color-2");
        padding-bottom: env(safe-area-inset-bottom);
        /deep/ .van-nav-bar__content {
            @include background_color("background-color-10");
            height: torem(44);
        }
        /deep/ .van-nav-bar__title {
            @include font_color("font-color");
            // color: red;
        }
        /deep/ .van-nav-bar .van-icon {
            @include font_color("font-color");
        }
        /deep/ .van-hairline--bottom::after{
            @include border_color("border-color-6");
        }
        width: 100%;
        // overflow: hidden;
        @include background_color("background-color-4");
        .apiBody {
            height: 100vh;
            overflow-y: auto;
            -webkit-overflow-scrolling: touch;
            .commont_body {
                padding: torem(16);
                // overflow-y: auto;
                // height: calc(100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom) - torem(44));
                // height: calc(
                //     100vh - env(safe-area-inset-top) - env(safe-area-inset-bottom) -
                //         44px
                // );
                .commont_content {
                    display: flex;
                    flex-direction: column;
                    .vitepress_box{
                        // width: 100%;
                        display: flex;
                        justify-content: space-between;
                        margin-top: torem(12);
                    }
                    span {
                        @include font_color("disale-color");

                        font-family: "HarmonyOS Sans SC";
                        font-style: normal;
                        font-weight: 400;
                        line-height: 150%; /* 36px */
                        font-size: torem(12);
                    }
                    .check {
                        color: #d9a31a !important;
                        font-family: "HarmonyOS Sans SC";
                        font-size: torem(12);
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        text-decoration: underline !important; /* 添加下划线 */
                    }
                    .faq{
                        color: #d9a31a !important;
                        font-family: "HarmonyOS Sans SC";
                        font-size: torem(12);
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }
                }
            }
            .pageList {
                padding: torem(24) 0 torem(74) 0;
                .page-item {
                    border-radius: 16px;
                    border: 2px solid rgba(0, 0, 0, 0.05);
                    @include background_color("dialog-background");
                    padding: torem(20) torem(16);
                    margin-bottom: torem(16);
                    .item-line {
                        width: 100%;
                        border-bottom: 2px solid rgba(0, 0, 0, 0.03);
                        margin: torem(20) 0;
                    }
                    .item-top {
                        display: flex;
                        align-items: center;
                        .item-title {
                            width: 48%;
                            display: flex;
                            flex-direction: column;
                            @include font_color("font-color");
                            font-family: "HarmonyOS Sans SC";
                            font-size: torem(12);
                            font-style: normal;
                            font-weight: 500;
                            line-height: normal;
                            .title {
                                @include font_color("disale-color");
                                font-family: "HarmonyOS Sans SC";
                                font-size: torem(10);
                                font-style: normal;
                                font-weight: 500;
                                line-height: normal;
                                margin-bottom: torem(12);
                            }
                            span {
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                            }
                        }
                    }
                }
            }
            .flot {
                position: fixed;
                bottom: 0;
                width: 100%;
                // background-color: #fff;
                @include background_color("background-color-4");

                display: flex;
                justify-content: center;
                padding: torem(12) 0;
                button {
                    width: calc(100% - 1.2rem);
                    margin: 0 auto;
                }
                /deep/ .van-button__text {
                    color: #000 !important;
                }
            }
        }
    }
    .images {
        margin-top: torem(24);
        position: relative;
    }

    [data-theme="moon"] {
        /deep/ .van-nav-bar {
            // background-color: none !important;

            background-color: red !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/apiKey/index.vue